import React from "react";
import Container from "./Container/Container";
import MainContainer from "./MainContainer/MainContainer";
import Sidebar from "./Sidebar/Sidebar";
import TopNavbar from "./TopNavbar/TopNavbar";
import Main from "./Main/Main";

const AppLayout = props => {
  const {
    sceneSetting,
    children,
    sidebarContent,
    appConfig,
    onStepChange,
    currentSubStepName,
    zoom,
    resetScene
  } = props;
  return (
    <Container>
      <TopNavbar
        resetScene={() => resetScene()}
        zoom={zoom}
        onStepChange={(type, stepId) => onStepChange(type, stepId)}
        appConfig={appConfig}
        sceneSetting={sceneSetting}
      />
      <MainContainer zoom={zoom}>
        <Main>{children}</Main>
        <Sidebar
          zoom={zoom}
          currentSubStepName={currentSubStepName}
          onStepChange={type => onStepChange(type)}
          sceneSetting={sceneSetting}
        >
          {sidebarContent}
        </Sidebar>
      </MainContainer>
    </Container>
  );
};

export default AppLayout;
